/**
 * Whether this is the first time this browser has shown something.
 *
 * For the few moments worth marking once — a result seen for the first
 * time — and not again on every visit after: a celebration repeated on
 * every look stops being one. Remembered in this browser only; a student
 * on a new machine sees it once more, which is no harm.
 */
const STORE = 'target.seen';

function read(): string[] {
  try {
    const raw = window.localStorage.getItem(STORE);
    const list: unknown = raw ? JSON.parse(raw) : [];
    return Array.isArray(list) ? list.filter((x): x is string => typeof x === 'string') : [];
  } catch {
    return [];
  }
}

/** True the first time a key is asked about, and false after; remembers it. */
export function firstSight(key: string): boolean {
  const seen = read();
  if (seen.includes(key)) return false;
  try {
    // The newest few hundred are plenty: older results are not revisited.
    window.localStorage.setItem(STORE, JSON.stringify([...seen, key].slice(-300)));
  } catch {
    // Private mode, full storage: the moment simply plays again next time.
  }
  return true;
}

export const prefersLessMotion = () =>
  typeof window !== 'undefined' && window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
